function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useToast, HStack, Stack, Text, IconButton, Icon, Heading } from '@chakra-ui/react';
import { faCheckCircle, faInfoCircle, faTimes, faWarning } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
function Notification(props) {
    var colorScheme = props.colorScheme;
    if (colorScheme == null && props.status === 'error') {
        colorScheme = 'red';
    }
    if (colorScheme == null && props.status === 'warning') {
        colorScheme = 'orange';
    }
    if (colorScheme == null && props.status === 'info') {
        colorScheme = 'primary';
    }
    if (colorScheme == null && props.status === 'success') {
        colorScheme = 'green';
    }
    var _props_icon;
    return /*#__PURE__*/ _jsxs(HStack, {
        paddingY: 2,
        paddingX: 4,
        borderRadius: "lg",
        alignItems: "center",
        spacing: 4,
        _light: {
            backgroundColor: "".concat(colorScheme, ".100"),
            color: "".concat(colorScheme, ".800")
        },
        _dark: {
            backgroundColor: "".concat(colorScheme, ".800"),
            color: "".concat(colorScheme, ".100")
        },
        children: [
            (_props_icon = props.icon) !== null && _props_icon !== void 0 ? _props_icon : null,
            props.icon == null && props.status === 'error' ? /*#__PURE__*/ _jsx(Icon, {
                as: FontAwesomeIcon,
                icon: faWarning
            }) : null,
            props.icon == null && props.status === 'warning' ? /*#__PURE__*/ _jsx(Icon, {
                as: FontAwesomeIcon,
                icon: faWarning
            }) : null,
            props.icon == null && props.status === 'info' ? /*#__PURE__*/ _jsx(Icon, {
                as: FontAwesomeIcon,
                icon: faInfoCircle
            }) : null,
            props.icon == null && props.status === 'success' ? /*#__PURE__*/ _jsx(Icon, {
                as: FontAwesomeIcon,
                icon: faCheckCircle
            }) : null,
            /*#__PURE__*/ _jsxs(Stack, {
                spacing: 0,
                children: [
                    props.title != null ? /*#__PURE__*/ _jsx(Heading, {
                        size: "sm",
                        children: props.title
                    }) : null,
                    props.description != null ? /*#__PURE__*/ _jsx(Text, {
                        fontSize: "sm",
                        children: props.description
                    }) : null
                ]
            }),
            /*#__PURE__*/ _jsx(IconButton, {
                size: "sm",
                marginLeft: "auto",
                "aria-label": "Close",
                colorScheme: colorScheme,
                icon: /*#__PURE__*/ _jsx(Icon, {
                    as: FontAwesomeIcon,
                    icon: faTimes
                }),
                onClick: props.onClose,
                variant: "ghost"
            })
        ]
    });
}
export default function useNotification() {
    var toast = useToast();
    return React.useCallback(function(message) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        toast(_object_spread({
            title: message,
            status: 'info',
            duration: 2000,
            position: 'top-right',
            render: Notification
        }, options));
    }, [
        toast
    ]);
}
